import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../../firebase-config";
import { db } from "../../../firebase-config";
import { app } from "../../../firebase-config";
import { async } from "@firebase/util";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  Firestore,
  query,
  where,
} from "firebase/firestore";
import Cookies from "universal-cookie";
import Modal from "react-modal";
import DatePicker, { setDefaultLocale } from "react-datepicker";
import Moment from "moment";

import MapAdd from "../map.module";
import ClubModal from "./ClubModal";
const axios = require("axios").default;
const header = {
  "Access-Control-Allow-Origin": "*",
  "content-type": "application/x-www-form-urlencoded",
};

const customStyles2 = {
  content: {
    top: "50%",
    left: "50%",
    width: "70%",
    height: "250px",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement(document.getElementById("root"));
// export default class Login extends Component {
const ClubsModule = (props) => {
  const cookies = new Cookies();
  const ClubsCollectionRef = collection(db, "clubs");
  const [clubs, setClubs] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [action, setAction] = useState("");
  const [club, setClub] = useState(null);
  //   const [minAge,setMinAge] = useState("");
  //   const [maxAge,setMaxAge] = useState("");
  //   const [price,setPrice] = useState("");
  //   const [startDate, setStartDate] = useState(new Date());
  //   const [endDate, setEndDate] = useState(new Date());
  //   const [isActive,setIsActive] = useState(false);
  //   const [product_id,setProduct_id] = useState("");
  //   const [price_id,setPrice_id] = useState("");

  useEffect(() => {
    // cookies.set('player', "", { path: '/' });
    getClubs();
  }, []);

  useEffect(() => {
    if (isLoading) {
      document.getElementById("data").style.display = "none";
      document.getElementById("loader").style.display = "block";
    } else {
      document.getElementById("data").style.display = "block";
      document.getElementById("loader").style.display = "none";
    }
  }, [isLoading]);

  const getClubs = async () => {
    const q = query(ClubsCollectionRef, where("uid", "==", props.userHome.uid));
    const data = await getDocs(q);
    setClubs(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setLoading(false);
  };

  var rowCounter = 0;

  let subtitle;
  const [modalIsOpenMap, setIsOpen2] = React.useState(false);
  function openModalmap(club) {
    // console.log(club);
    setClub(club);
    setIsOpen2(true);
  }

  function openModal() {
    setAction("Add New Club");
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000000";
  }

  function closeModal2() {
    setIsOpen2(false);
  }

  const setDefault = async (club_name_add, club_id_add) => {
    setLoading(true);
    const userDoc = doc(db, "users", cookies.get("uid_record"));
    var date = new Date();
    const newFields = {
      date_modified: date,
      by: props.userData.name + " " + props.userData.lastname,
      club_id: club_id_add,
      club_name: club_name_add,
    };
    await updateDoc(userDoc, newFields).then(() => {
      window.location = "/admin/clubs";
    });
  };

  // callback function for when the club modal is closed
  const finalizeModal = () => {
    setAction(null); // null will unmount the modal component from the virtual DOM
    getClubs(); // refreshes the club list
  };

  return (
    <>
      <h2>Registered Clubs</h2>
      <div className="row">
        <div className="col-lg-12" style={{ display: "flex" }}>
          <button
            className="btn btn-primary btn-sm"
            style={{ marginLeft: "0px" }}
            onClick={openModal}
          >
            Add New Club
          </button>
          <br></br>
        </div>
      </div>
      <div id="data" style={{ overflowX: "scroll" }}>
        <div className="row">
          <div className="col-lg-12">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Club Name</th>
                  <th>Address</th>
                  <th>League Name</th>
                  <th>Phone</th>
                  <th>Website</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {clubs.map((club) => {
                  rowCounter++;
                  // console.log(club);
                  var address = "";
                  if (club.Address != "") {
                    address =
                      club.Address +
                      ", " +
                      club.City +
                      ", " +
                      club.State +
                      ", " +
                      club.ZIP;
                  }

                  return (
                    <>
                      <tr
                        key={club.id}
                        style={
                          props.userData.club_id == club.id
                            ? { backgroundColor: " #baf5bc " }
                            : {}
                        }
                      >
                        <td>{rowCounter}</td>
                        <td>{club.club_name}</td>
                        <td>
                          {address}
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              openModalmap(club);
                            }}
                          >
                            Edit
                          </button>
                        </td>
                        <td>{club.league_name}</td>
                        <td>{club.phone}</td>
                        <td>{club.website}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                              setClub(club);
                              setAction("Update Club");
                            }}
                          >
                            Modify
                          </button>
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                              setDefault(club.club_name, club.id);
                            }}
                          >
                            Set Default
                          </button>
                        </td>
                      </tr>
                      {/* <tr>
                                <td colSpan={7}>
                                    {(props.userData.club_id==club.id)?<MapAdd club={club}></MapAdd>:""}
                                </td>
                            </tr> */}
                    </>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <div className="loader-container" id="loader">
        <div className="loader"></div>
      </div>
      {/* if action !== null then mount component */}
      {action && (
        <ClubModal
          closeModal={() => {setClub(null); setAction(null);}}
          action={action}
          finalize={finalizeModal}
          club={club}
          userHome={props.userHome}
        />
      )}
      <Modal
        isOpen={modalIsOpenMap}
        onRequestClose={closeModal2}
        style={customStyles2}
        contentLabel="Example Modal"
        closeTimeoutMS={500}
      >
        {modalIsOpenMap ? (
          <MapAdd
            club={club}
            closeModal2={closeModal2}
            getClubs={getClubs}
            username={props.userData.name}
            lastname={props.userData.lastname}
          ></MapAdd>
        ) : (
          ""
        )}
      </Modal>
    </>
  );
};

export default ClubsModule;
